import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { compose } from 'recompose'
import { connect } from 'react-redux';
//import {messaging} from '../../firebase/firebase'
//import store from '../../store'
import { withRouter } from 'react-router-dom';
import * as routes from '../../constants/routes';

const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
});



class AppNotificationItem extends React.Component {
  state = {
    open: false,
  };
  

  handleClick = () => {

   this.props.history.push(routes.CANIDATELIST)
   this.props.dispatchEventDetails(this.props.notification.data.event)
   this.props.onOpenNotification({component: 'canidateList', hidden: true})
   
   

  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    const setNotification = {
      visible: false,
      notId: this.props.notification.collapse_key
    }
    // close Notification
    this.props.onToggleNotification(setNotification);
  };


  render() {
    const { classes, notification } = this.props;
    
    const getMessageId = () => {
      if (notification){
        const messageId = notification.collapse_key
        return messageId
    } else {
      const messageId = 'message-id'
      return messageId
    }
    }

    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={notification.visible}
          //autoHideDuration={12000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': getMessageId(),
          }}
          message={notification
                    ? <div><h3>Neuer Hilfebedarf</h3><span id={getMessageId()}>{notification.notification.body}</span></div>
                    : <span id={getMessageId()}>kein Text</span>
                    }
          action={[
            <Button key="open" color="secondary" size="small" onClick={this.handleClick}>
              Öffnen
            </Button>,
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onToggleNotification: (payload)=>dispatch({ type: 'TOGGLE_NOTIFICATION', payload }),
  onOpenNotification: (payload)=>dispatch({ type: 'TOGGLE_VIEW', payload}),
  dispatchEventDetails: (payload) => dispatch({type: 'FETCH_APPLICATION_DETAILS', payload})
  
})

const mapStateToProps = (state) => ({
  newNotification: state.notificationState.newNotification,
  events: state.eventState.eventList
})



AppNotificationItem.propTypes = {
  classes: PropTypes.object.isRequired,
};
 


export default compose( 
withRouter,
withStyles(styles),
connect(mapStateToProps, mapDispatchToProps)
)(AppNotificationItem);


// WEBPACK FOOTER //
// ./src/Components/Notification/AppNotificationItem.js